/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';
/**
 * Utility module for holding general common code between the main Enervee Angular applications.
 */

const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const getFetchModule = require('@utils/get_fetch/getFetchModule');
const SwiftypeService = require('./swiftypeService');

const swiftypeModule = angular
    .module('enervee_utils.swiftype', [
        commonModule.name,
        consumersModule.name,
        getFetchModule.name,
    ])
    .factory('SwiftypeService', SwiftypeService);

module.exports = swiftypeModule;